<template>
    <div>
        <div class="text-center w-full sm:w-2/3 mx-auto">
            <h3 v-text="headerText"></h3>
            <h5 class="uppercase" v-text="title"></h5>
            <div class="flex items-center justify-between">
                <div class="accountMyBoxDateToggle__ButtonContainer">
                    <button
                        v-if="canDecrement"
                        class="accountMyBoxDateToggle__icon accountMyBoxDateToggle__icon--previous"
                        @click="$store.dispatch('cms/decrementActiveScheduleWeek')">
                    </button>
                </div>
                <div class="">
                    <p class="m-0" v-text="dateString"></p>
                </div>
                <div class="accountMyBoxDateToggle__ButtonContainer">
                    <button
                        v-if="canIncrement"
                        class="accountMyBoxDateToggle__icon accountMyBoxDateToggle__icon--next"
                        @click="$store.dispatch('cms/incrementActiveScheduleWeek')">
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DateToggle',
    computed: {
        ...mapGetters({
            date: 'cms/getActiveScheduleDeliveryDate',
            canDecrement: 'cms/canDecrementActiveSchedule',
            canIncrement: 'cms/canIncrementActiveSchedule',
            activeWeekStart: 'cms/getActiveWeekStart',
            isUSA: 'localisation/isUSA',
        }),
        dateString() {
            return this.date instanceof this.$moment ? this.date.format('dddd Do MMM') : null;
        },
        title() {
            let title = '';
            if (this.isUSA) {
                title = this.$moment().isAfter(this.date.clone().add(16, 'hours')) ? this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERY_ON') : this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERING_ON');
            } else {
                title = this.$moment().isAfter(this.date) ? this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERY_ON') : this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERING_ON');
            }
            this.$emit('update-title', title);

            return title;
        },
        headerText() {
            if (this.$moment().isBefore(this.$moment(this.activeWeekStart))) {
                return this.$t('SUBSCRIPTION_DROP_DOWN_NEXT_WEEK');
            }

            if (this.$moment(this.date).startOf('week').isBefore(this.$moment(this.activeWeekStart))) {
                return this.$t('SUBSCRIPTION_DROP_DOWN_PREVIOUS');
            }

            return this.$t('SUBSCRIPTION_DROP_DOWN_NEXT_WEEK');
        },
    },
};
</script>
